<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->

<div class="emptyScreen wccard d-flex justify-content-center align-items-center" *ngIf="talentpools?.length == 0 && !talentpoolname && !showLoader">
  <div class="createFirstTalenpool">
    <div class="text-center">
      <div class="text-center mb-3"><img src="../../../assets/images/bacgroundvectore-2.png" alt="" style="width: 110px;"></div>
      <p class="f-16 font-weight-600 text-center">No talentpools shared with you</p>
    </div>
  </div>
</div>

<div class="mb-3px mb-2 talenpool-sticky-header" *ngIf="(talentpools?.length != 0 || talentpoolname) && !showLoader">
  <div class="col wccard py-2 d-flex justify-content-between card-bottom-space">
    <div class="d-flex align-items-center">
      <div class="py-2 talentpool-search position-relative">
        <input data-testid="auto-app-shared-talentpools-listing-input-1" type="text" class="wc-form-control nobg" [(ngModel)]="talentpoolname"
          (input)="searchtalentpools($event)" />
        <i class="fas fa-search"></i>
        <div *ngIf="showSearchLoader" class="spinner-border position-absolute text-black" style="top:4px; right: 4px; background-color: #fff;" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="mx-1">
        <span class="dropdown ats-dropBtn mx-1">
          <button data-testid="auto-app-shared-talentpools-listing-button-1" class="ats-btn btn-break dropdown-toggle ml-3px" type="button" id="userDropdownButton"
            appDropdownToggle aria-haspopup="true" aria-expanded="false">
            <i class="far fa-sort-alt isActive mr-2"></i>Sort By
          </button>
          <div class="dropdown-menu" aria-labelledby="userDropdownButton">
            <a data-testid="auto-app-shared-talentpools-listing-a-1" class="dropdown-item f-14" routerLinkActive="active"
              (click)="sorttalenpoolList('nameasc')">Alphabetically: A-Z</a>
            <a data-testid="auto-app-shared-talentpools-listing-a-2" class="dropdown-item f-14" routerLinkActive="active"
              (click)="sorttalenpoolList('namedesc')">Alphabetically: Z-A</a>
            <a data-testid="auto-app-shared-talentpools-listing-a-3" class="dropdown-item f-14" routerLinkActive="active" (click)="sorttalenpoolList('createdonasc')">Created on: Oldest to Newest</a>
            <a data-testid="auto-app-shared-talentpools-listing-a-4" class="dropdown-item f-14" routerLinkActive="active" (click)="sorttalenpoolList('createdondesc')">Created On: Newest to Oldest</a>
            <a data-testid="auto-app-shared-talentpools-listing-a-5" class="dropdown-item f-14" routerLinkActive="active" (click)="sorttalenpoolList('updatedonasc')">Last Updated On: Oldest to Recent</a>
            <a data-testid="auto-app-shared-talentpools-listing-a-6" class="dropdown-item f-14" routerLinkActive="active" (click)="sorttalenpoolList('updatedondesc')">Last Updated On: Recent to Oldest</a>
          </div>
        </span>
      </div>
    </div>
  </div>
</div>
 <div class="d-flex headerRow align-items-center">
    <div class="" *ngFor="let header of talentpoolHeaders" [ngClass]="header == 'Talentpool Name' ? 'col-4': header == 'Actions' ? 'col-2' : 'col'">
      <span *ngIf="header == 'Recommended Matches'" class="gen-ai-text"><i class="fa-solid fa-stars mr-1"></i></span>{{header}}
    </div>
  </div>
<div class="data-card pt-0" style="overflow: hidden; border-top-left-radius: 0;border-top-right-radius: 0; margin-top: -1px;"  *ngIf="talentpools?.length != 0 && !showLoader">
  <div>
   <div class="d-flex datarow align-items-center" *ngFor="let talent of talentpools">
    <div class="col-4" (click)="OpenCandidateList(talent);">
      <span class="mb-2 pointer" [matTooltip]="talent?.name | titlecase" [matTooltipClass]="{ 'big-tooltip': true }"  matTooltipPosition="above">{{talent?.name |titlecase}}</span>
      <p class="mb-0 mt-2" style="color: #B3B3B3;"><i class="fa-regular fa-user mr-3"></i>{{talent?.firstname}} {{talent?.lastname}}</p>
    </div>
    <div class="col" (click)="OpenCandidateList(talent);">
       <p class="mb-0 pointer">{{talent?.candidatecount}}</p>
    </div>
    <div class="col">
      <p class="mb-2 d-flex align-items-center pointer" *ngIf="talent?.candidatecount >= 10" (click)="navigateToSimilarCandidates(talent?.talentpoolid)"> <span class="text-green-active" ><i class="fa-solid fa-circle f-10 mr-1"></i></span> Available</p>
      <p class="mb-0 d-flex align-items-center" *ngIf="talent?.candidatecount < 10"><span class="text-gray-inactive" ><i class="fa-solid fa-circle f-10 mr-1"></i></span>  Not Available</p>
    </div>
    <div class="col">
      <p class="mb-0" style="color: #B3B3B3;">{{talent?.createdon | date:'dd MMM yyyy'}}</p>
    </div>
    <div class="col-2">
       <span class="ats-cta-btn mr-2 pointer disable-btn" [matTooltipClass]="{ 'big-tooltip': true }" matTooltip="Share Talent Pool" matTooltipPosition="above" (click)="triggerTalentpoolSharing(talent)">
        <i class="fa-sharp fa-light fa-share-nodes"></i>
      </span>
      <span class="ats-cta-btn mr-2 pointer disable-btn" [matTooltipClass]="{ 'big-tooltip': true }" matTooltip="Delete Talent Pool" matTooltipPosition="above" (click)="deleteTalentpoolConfirmation(talent)">
       <i class="fa-light fa-trash"></i>
      </span>
       <span class="ats-cta-btn pointer disable-btn" [matTooltipClass]="{ 'big-tooltip': true }" matTooltip="Edit Talent Pool" matTooltipPosition="above" (click)="editTalentpool(talent);">
        <i class="fa-regular fa-pen-to-square"></i>
      </span>
    </div>
   </div>
  </div>
</div>
<!-- <div class="row mb-3px ml-0" *ngIf="talentpools?.length != 0 && !showLoader">
  <div class="col-md-4 pl-0 mb-3" *ngFor="let talent of talentpools">
    <div class="wccard card-data px-3 py-2 d-flex justify-content-between flex-column" [ngClass]="{'border-change': talent.selected, 'border-white': !talent.selected}">
      <div class="">
        <div class="">
          <div class="position-relative w-100 d-flex">
            <div class="d-grid align-items-center pointer f-16 font-weight-600 text-capitalize" style="width: 250px;" (click)="OpenCandidateList(talent);"  [matTooltip]="talent?.name | titlecase" [matTooltipClass]="{ 'big-tooltip': true }"  matTooltipPosition="above">
              <span class="text-truncate">{{talent?.name }}</span>
            </div>
            <div class="position-absolute tr0 pointer" (click)="OpenCandidateList(talent);">
              <div class="d-flex align-items-center">
                <i class="fa-light fa-users f-14 text-black"></i> &nbsp;&nbsp;
                <span class="f-16 font-weight-600">{{talent?.candidatecount}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col d-flex align-items-center float-right pr-0">
            <div class="text-9696 f-12 d-flex align-items-center"><i class="far fa-user"></i><span class="ml-2 f-12">{{talent?.firstname}}
                {{talent?.lastname}}</span>
              <i class="fas fa-circle mx-2" style="font-size: 4px;"></i> <span class="f-12">{{talent?.createdon
                | date:'dd MMM yyyy'}}</span>
              <span class="dropdown ats-dropBtn mx-1 ml-2">&nbsp;</span>
            </div>
          </div>
        </div>
        <div class="f-12 text-9696 line-clamp pointer" (click)="OpenCandidateList(talent);" *ngIf="talent?.description">
          <hr class="mb-0 mb-1-5">
          {{talent?.description}}
        </div>
      </div>
    </div>
  </div>
</div> -->

<div class="row" *ngIf="talentpools?.length == 0 && (talentpoolname != null && talentpoolname != '') && !showLoader">
  <div class="col text-center py-3">
    <div class="wccard">
      <div class="row">
        <div class="col">
          <img src="../assets/images/talentpool-empty.png" class="img-fluid" alt="" srcset="">
        </div>
      </div>
      <div class="row">

      </div>
      <div>
        <p class="font-weight-500 f-18 py-3">Results Not Found!</p>
      </div>
    </div>
  </div>
</div>

<div class="emptyScreen" *ngIf="showLoader">
  <div class="loader text-center">
    <img style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
  </div>
</div>
